// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1eu0C","image":"styles_image__3eLUd","text":"styles_text__1qYr-"};